import { gql } from '@apollo/client';

export const QUERY_ROLE_PREFERENCES = gql`
  query rolePreferences {
    rolePreferences: willingnesses {
      id
      name
      code
    }
  }
`;
